import { CSSObject } from '@emotion/react';
import { useTheme } from '@cvent/carina/components/ThemeProvider';

export const useDividerStyle = (): Record<string, CSSObject> => {
  const { borderColor } = useTheme();

  return {
    divider: {
      padding: 0,
      border: `1px solid ${borderColor.soft}`
    }
  };
};
